import { difference, keys } from "lodash-es";

const defaultState = () => {
	return {
		members: {
			count: 0,
			results: [],
		},
		member: {
			id: null,
			role: null,
			role_value: null,
			user: null,
			company: null,
			type: "Employee",
			status: "Active",
			is_active: true,
			display_name: null,
			email: null,
		},
	};
};

const state = {
	members: defaultState().members,
	member: defaultState().member,
};

const getters = {
	members: (state) => {
		return state.members;
	},
	member: (state) => {
		return state.member;
	},
};

const actions = {};

const mutations = {
	GET_MEMBERS: (state, payload) => {
		if (payload) {
			state.members.count += payload.count;
			state.members.results = state.members.results.concat(
				payload.results.map((item) => {
					item.type = item.type.replace("Corporate", "Company");

					return item;
				})
			);
		} else {
			state.members = defaultState().members;
		}
	},
	CREATE_MEMBER: (state, payload) => {
		payload.data.type = payload.data.type.replace("Corporate", "Company");

		state.members.count += 1;
		state.members.results.push(payload.data);
	},
	READ_MEMBER: (state, payload) => {
		if (payload) {
			payload.data.display_name =
				payload.data.display_name ||
				`${payload.data.user.first_name} ${payload.data.user.last_name}`;
			payload.data.email = payload.data.email || payload.data.user.email;

			state.member = payload.data;
		} else {
			state.member = defaultState().member;
		}
	},
	UPDATE_MEMBER: (state, payload) => {
		const index = state.members.results.findIndex(
			(item) => item.id == payload.data.id
		);

		payload.data.display_name =
			payload.data.display_name ||
			`${payload.data.user.first_name} ${payload.data.user.last_name}`;
		payload.data.type = payload.data.type.replace("Corporate", "Company");
		payload.data.is_active =
			payload.data.is_active || payload.data.user.is_active;

		if (0 <= index) {
			const diff = difference(
				keys(state.members.results[index]),
				keys(payload.data)
			);

			if (0 < diff.length)
				diff.forEach((item) => {
					payload.data[item] = state.members.results[index][item];
				});

			state.members.results.splice(index, 1, payload.data);
		}
	},
	DELETE_MEMBER: (state, payload) => {
		const index = state.members.results.findIndex(
			(item) => item.id == payload.data.id
		);

		if (0 <= index) {
			state.members.count -= 1;
			state.members.results.splice(index, 1);
		}

		state.member =
			state.member.id == payload.data.id
				? defaultState().member
				: state.member;
	},
};

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations,
};
